module.exports = require('./components/TimePicker.vue');
